export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    action: 'read',
    children: [
      {
        title: 'Home',
        route: 'home',
        icon: 'HomeIcon',
      },
      {
        title: 'Admin',
        route: 'Admin',
        icon: 'FileIcon',
        action: 'read',
      },
    ],
  },
]
